export const tr = {
    cancel: 'İptal',
    save: 'Tüm formatları kaydet',
    sidebarTitle: 'Boyutları',
    subtitle: 'Artık her format için görselin merkezi manuel olarak seçilebilir.',
    title: 'Görsel konumlandırma'
};
